var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 15,
    viewBox: "0 0 28 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.5858L13.3 2.28585C13.4869 2.10262 13.7382 1.99999 14 1.99999C14.2618 1.99999 14.5131 2.10262 14.7 2.28585L26 13.5858",
    stroke: "url(#paint0_linear_661_3212)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_661_3212",
    x1: 26,
    y1: 7.79292,
    x2: 2,
    y2: 7.79292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0797FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluearrow);
export default __webpack_public_path__ + "static/media/blue arrow.4c3ad1d9d8c35484fa46e6614ac0a238.svg";
export { ForwardRef as ReactComponent };